import React from 'react'

const GearIcon = () => {
	return (
		<svg width={35} height={35} viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M17.504 23.571a6.331 6.331 0 01-4.414-1.778 5.988 5.988 0 01-1.828-4.293c0-1.61.658-3.154 1.829-4.293a6.331 6.331 0 014.413-1.778c1.655 0 3.243.64 4.413 1.778a5.988 5.988 0 011.828 4.293c0 1.61-.657 3.154-1.828 4.293a6.331 6.331 0 01-4.413 1.778zm13.25-4.389c.071-.554.124-1.11.124-1.682 0-.573-.053-1.145-.124-1.735l3.762-2.827a.859.859 0 00.214-1.11l-3.566-6.002c-.214-.382-.696-.538-1.088-.382l-4.44 1.735c-.928-.676-1.89-1.266-3.014-1.7l-.66-4.597a.895.895 0 00-.892-.728h-7.133a.895.895 0 00-.891.728l-.66 4.597c-1.123.434-2.086 1.024-3.014 1.7l-4.44-1.735a.888.888 0 00-1.088.382L.277 11.828a.84.84 0 00.214 1.11l3.763 2.827c-.071.59-.125 1.162-.125 1.735 0 .572.054 1.128.125 1.683L.491 22.062a.84.84 0 00-.214 1.11l3.567 6.002c.214.381.696.52 1.088.381l4.44-1.751c.928.693 1.89 1.283 3.014 1.717l.66 4.597a.895.895 0 00.891.728h7.133c.446 0 .82-.312.892-.728l.66-4.597a13.074 13.074 0 003.014-1.717l4.44 1.752c.392.138.874 0 1.088-.382l3.566-6.002a.86.86 0 00-.214-1.11l-3.762-2.88z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default GearIcon
